import type { FC } from 'react'

export interface Props {}
interface State {}

const ContentPrivacy: FC<Props> = () => {
  return (
    <div className="prose-sm mx-auto pt-8 pb-20 dark:prose-invert sm:prose">
      <h1>개인정보처리방침</h1>
      <h2>제 1조 (개인정보의 처리목적)</h2>
      <h3>가. 서비스 기본 기능의 제공</h3>
      <p>
        서비스 이용자 간 메시지 송수신 서비스를 제공합니다. 이용자 닉네임, 지역,
        회사 정보 등은 이용자가 다른 이용자와의 소통과정에서 자신을 설명하기
        위해 등록되는 정보로서 회원 간에는 위 정보가 서로에게 공개됩니다.
      </p>
      <h3>나. 회원관리</h3>
      <p>
        회원제 서비스 이용에 따른 기기식별, 약관위반회원(이용정지 회원 및
        계약해지된 이용정지 회원)의 부정 이용방지와 비인가 사용방지, 가입의사
        확인, 가입 및 가입횟수 제한, 분쟁 조정을 위한 기록보존, 불만처리 등
        민원처리, 고지사항 전달
      </p>
      <h3>다. 서비스 통계에 활용</h3>
      <p>접속빈도 파악, 회원의 서비스 이용에 대한 통계</p>
      <h2>개인정보의 공유 및 제공</h2>
      <p>
        회사는 이용자들의 개인정보를 "개인정보의 수집목적 및 이용목적"에서
        고지한 범위 내에서 사용하며, 이용자의 사전동의 없이는 범위를 초과하여
        이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다.
        다만, 아래의 경우에는 예외로 합니다.
      </p>
      <ul>
        <li>이용자들이 사전에 공개에 동의한 경우</li>
        <li>
          법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에
          따라 수사기관의 요구가 있는 경우
        </li>
      </ul>
      <h2>제 2조 (개인정보의 처리 및 보유기간)</h2>
      <p>
        이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면
        지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한
        기간 동안 보존합니다.
      </p>
      <p>
        <ul>
          <li>계약에 관한 기록</li>
          <li>보존 이유: 전자상거래 등에서의 소비자보호에 관한 법률</li>
          <li>보존 기간: 5년</li>
        </ul>
      </p>
      <p>
        <ul>
          <li>소비자의 불만 또는 분쟁처리에 관한 기록</li>
          <li>보존 이유: 전자상거래 등에서의 소비자보호에 관한 법률</li>
          <li>보존 기간: 3년</li>
        </ul>
      </p>
      <p>
        <ul>
          <li>방문에 관한 기록</li>
          <li>보존 이유: 통신비밀보호법</li>
          <li>보존 기간: 3개월</li>
        </ul>
      </p>
      <p>
        <ul>
          <li>본인확인에 관한 기록</li>
          <li>보존 이유: 정보통신망 이용촉진 및 정보보호 등에 관한 법률</li>
          <li>보존 기간: 3개월</li>
        </ul>
      </p>
      <p>
        <ul>
          <li>이용정책위반에 의한 정보보유 사유</li>
          <li>보존 이유: 부정이용방지</li>
          <li>보존 기간: 3개월</li>
        </ul>
      </p>
      <h2>제 3조 (이용자 및 법정대리인의 권리·의무 및 행사방법)</h2>
      <p>
        정보주체는 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를
        행사할 수 있습니다.
      </p>
      <p>
        제 1항에 따른 권리 행사는 「개인정보 보호법」 시행령 제 41조 제 1항에
        따라 서면, 전자우편 등을 통하여 하실 수 있으며 이에 대해 지체 없이
        조치합니다.
      </p>
      <p>
        제 1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등
        대리인을 통하여 하실 수 있습니다. 이 경우 "개인정보 처리 방법에 관한
        고시(제2020-7호)" 별지 제 11호 서식에 따른 위임장을 제출하셔야 합니다.
      </p>
      <p>
        개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항,
        제37조 제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다.
      </p>
      <p>
        개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로
        명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.
      </p>
      <p>
        정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시
        열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.
      </p>
      <p>
        이용자는 언제든지 '정보'에서 자신의 개인정보를 조회하거나 수정할 수
        있습니다.
      </p>
      <p>
        이용자는 언제든지 '탈퇴하기' 등을 통해 개인정보의 수집 및 이용 동의를
        철회할 수 있습니다.
      </p>
      <p>
        만 14세 미만 아동의 경우, 법정대리인이 아동의 개인정보를 조회하거나
        수정할 권리, 수집 및 이용 동의를 철회할 권리를 가집니다.
      </p>
      <p>
        이용자가 개인정보의 오류에 대한 정정을 요청한 경우, 정정을 완료하기
        전까지 해당 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된
        개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체
        없이 통지하여 정정이 이루어지도록 하겠습니다.
      </p>
      <h2>제 4조 (개인정보처리의 위탁)</h2>
      <p>
        회사는 서비스 향상을 위하여 아래와 같이 개인정보를 위탁하고 있으며, 관계
        법령에 따라 위탁 계약 시 개인정보가 안전하게 관리될 수 있도록 필요한
        사항을 규정하고 있습니다. 회사의 개인정보 위탁처리 기관 및 위탁업무
        내용은 아래와 같습니다.
      </p>
      <ul>
        <li>Supabase: 데이터베이스</li>
      </ul>
      <h2>제 5조 (처리하는 개인정보 항목)</h2>
      <p>
        서비스 이용과정에서 아래와 같은 정보들이 생성되어 수집될 수 있습니다.
      </p>
      <ul>
        <li>선호하는 컴퓨터 언어</li>
        <li>선호하는 컴퓨터 기술</li>
        <li>직무 분야</li>
      </ul>
      <h2>제 6조 (개인정보 수집 방법)</h2>
      <p>회사는 다음과 같은 방법으로 개인정보를 수집합니다.</p>
      <ul>
        <li>프로그램을 실행 또는 사용함으로써 자동으로 수집</li>
        <li>서비스 가입이나 사용 중 이용자의 자발적 제공을 통한 수집</li>
      </ul>
      <h2>제 7조 (개인정보의 파기)</h2>
      <p>
        개인정보의 보유기간이 경과했거나 처리목적이 달성된 경우에는 해당
        개인정보를 파기합니다. 다만, 법령에서 일정 기간 정보보관 의무를 부과하는
        경우네느 해당 기간 동안 보관합니다.
      </p>
      <h3>파기절차</h3>
      <p>보유기간이 경과한 개인정보는 종료일로부터 지체 없이 파기합니다.</p>
      <h3>파기방법</h3>
      <p>
        전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 방법으로
        삭제합니다.
      </p>
      <h2>제 8조 (개인정보 보호책임자)</h2>
      <p>
        귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련
        민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다. 회사는
        이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.
      </p>
      <ul>
        <li>개인정보 관리책임자</li>
        <li>이름: 김동욱</li>
        <li>메일: wcgo2ling@gmail.com</li>
        <li>이 개인정보처리방침은 2022년 10월 18일부터 적용됩니다.</li>
      </ul>
    </div>
  )
}

export default ContentPrivacy
